import React from "react";
import "./AdminDashboardHome.css";

export default function SectionHeader({ icon, title, subtitle }) {
  return (
    <div className="adh-section-header">
      <div>
        <h3 className="adh-section-title">
          {icon && <i className={`fa-solid ${icon}`} aria-hidden="true"></i>}
          {title}
        </h3>
        {subtitle && <p className="adh-section-subtitle">{subtitle}</p>}
      </div>
    </div>
  );
}
